<div class="permissions">
  <div class="permissions__header">
    <span class="permissions__header-label">{{'desktop' | translate |async}}</span>
    <mat-slide-toggle
      labelPosition="before"
      [checked]="store.desktopPermissionsEnabled()"
      (change)="store.setPlatform(ClientPlatform.DESKTOP, $event.checked)"
      [disabled]="store.isAdmin()"
    ></mat-slide-toggle>
  </div>

  <div class="permissions__tree">
    @for (module of translatedDesktopTree(); track module) {
      <ng-container
        *ngTemplateOutlet="
          permissionTree;
          context: {
            module: module,
            platform: ClientPlatform.DESKTOP
          }
        "
      ></ng-container>
    }
  </div>

  @if (appStore.hasMobileModules()) {
    <div class="permissions__header">
      <span class="permissions__header-label">{{'mobile' | translate | async}}</span>
      <mat-slide-toggle
        labelPosition="before"
        [checked]="store.mobilePermissionsEnabled()"
        (change)="store.setPlatform(ClientPlatform.MOBILE, $event.checked)"
        [disabled]="store.isAdmin()"
      ></mat-slide-toggle>
    </div>

    <div class="permissions__tree">
      @for (module of translatedMobileTree(); track module) {
        <ng-container
          *ngTemplateOutlet="
            permissionTree;
            context: {
              module: module,
              platform: ClientPlatform.MOBILE
            }
          "
        ></ng-container>
      }
    </div>
  }
</div>

<ng-template #permissionTree let-module="module" let-platform="platform">
  <mat-tree
    [dataSource]="getDataSource(module)"
    [childrenAccessor]="childrenAccessor"
    [trackBy]="trackBy"
  >
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      isExpandable
      [isExpanded]="true"
    >
      <div class="permission-node">
        <mat-checkbox
          [checked]="node.selected"
          (change)="store.togglePermission(node, $event.checked, platform)"
          [disabled]="store.isAdmin()"
          class="permission-node__checkbox"
        ></mat-checkbox>
        <div class="permission-node__name">{{ node.name }}</div>
        <div class="permission-node__description">{{ node.description }}</div>
        <mat-divider class="permission-node__divider"></mat-divider>
      </div>
    </mat-tree-node>
  </mat-tree>
</ng-template>
